import { Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ActionEvent,
  ActionService,
  filterActionEventByAction,
  mapIsRunning,
} from '@fmnts/common/actions';
import { hasProperty, isString } from '@fmnts/core';
import { AbstractGraphNodeBuilder } from '@fmnts/declarative-forms/core';

export enum ActionNodeName {
  FromActionEvent = 'actions.from-action',
}

export enum ActionOperatorName {
  MapToIsRunning = 'actions.map-running',
}

/**
 * Builder for `ActionService` related graph nodes
 */
@Injectable()
export class ActionGraphNodeBuilder extends AbstractGraphNodeBuilder<
  ActionNodeName,
  ActionOperatorName
> {
  constructor(@Optional() private actionService: ActionService) {
    super();

    // Not all forms might use the action service
    if (!this.actionService) {
      return;
    }

    // Add sources
    this.addNode(ActionNodeName.FromActionEvent, (def) =>
      this.fromActionEvent(def.options),
    );

    // Add operators
    this.addOperator(ActionOperatorName.MapToIsRunning, () => mapIsRunning());
  }

  /**
   * @returns
   * Observable from action events
   */
  public fromActionEvent(options?: unknown): Observable<ActionEvent<unknown>> {
    const action = hasProperty('action', isString)(options)
      ? options.action
      : null;

    const { actionEvents$ } = this.actionService;

    return !action
      ? actionEvents$
      : actionEvents$.pipe(filterActionEventByAction(action));
  }
}
